import {Component, OnInit} from '@angular/core';
import {ScrollService} from "../../../services/scroll-service";
import {IconComponent} from "../icon/icon.component";
import {Icons} from "../../../model/icon";
import {Location, NgIf, NgStyle} from "@angular/common";
import {getClipPathForSector} from "../../../functions/getSector";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-main-loading',
  imports: [
    IconComponent,
    NgStyle,
    NgIf
  ],
  templateUrl: './main-loading.component.html',
  styleUrl: './main-loading.component.scss',
  animations: [
    trigger('fadeOut', [
      state('visible', style({ opacity: 1 })),
      state('invisible', style({ opacity: 0 })),
      transition('visible => invisible', [
        animate('3s ease-in-out') // Длительность анимации 1 секунда
      ]),
      transition('invisible => visible', [
        animate('3s ease-in-out')
      ])
    ])
  ]
})
export class MainLoadingComponent implements OnInit{

  constructor(
      protected scrollService: ScrollService,
      public location: Location,
  ) {
  }
  display: boolean = true;
  progress = 0;
  isLoading = true;
  clipPath: string = 'polygon(50% 50%, 50% 50%, 50% 50%)';
  isVisible = true;


  sliders: string[] = [
    'app/assets/loading-sliders/1.jpeg',
    'app/assets/loading-sliders/2.jpeg',
    'app/assets/loading-sliders/3.jpeg',
    'app/assets/loading-sliders/4.jpeg',
    'app/assets/loading-sliders/5.jpg',
  ];

  currentBack: string = this.sliders[0];



  ngOnInit() {
    if (this.location.path() == '') {
      this.scrollService.lockScroll();
      this.updateClipPath();
      this.simulateLoading();
    } else {
      this.display = false;
    }
  }
  simulateLoading() {
    const interval = setInterval(() => {
      const randomIncrement = 1 + Math.floor(Math.random() * 10);
      this.progress += randomIncrement;
      this.updateClipPath();
      if (this.progress >= 100) {
        this.progress = 100;
        clearInterval(interval);
        this.scrollService.unlockScroll();
        this.isLoading = false;
        this.isVisible = false;
        setTimeout(() => {
          this.display = false;
        }, 3000);
      }
    }, 500);
  }


  setStyle() {
    const display = !this.display ? 'display: none;' : '';
    // let url;
    // switch (true) {
    //   case this.progress < 20: {
    //     url = 'app/assets/loading-sliders/1.jpeg';
    //     break;
    //   }
    //   case this.progress < 40: {
    //     url = 'app/assets/loading-sliders/2.jpeg';
    //     break;
    //   }
    //   case this.progress < 60: {
    //     url = 'app/assets/loading-sliders/3.jpeg';
    //     break;
    //   }
    //   case this.progress < 80: {
    //     url = 'app/assets/loading-sliders/4.jpeg';
    //     break;
    //   }
    //   case this.progress < 100: {
    //     url = 'app/assets/loading-sliders/5.jpg';
    //     break;
    //   }
    //   default: {
    //     url = 'app/assets/loading-sliders/5.jpg';
    //     break;
    //   }
    // }
    // const background = `background-image: url("${url}");`;
    // return `${display}${background}`
    return `${display}`
  }


  setBack(url: string) {
    return `background-image: url("${url}");`;
  }



  updateClipPath() {
    const percentage = this.progress / 100;
    const angle = Math.round(percentage * 360);
    this.clipPath = getClipPathForSector(angle);

  }

  protected readonly Icons = Icons;
}
